export default __webpack_public_path__ + "static/Carpet-Removal-6b93d4df6f44d98913c5beb5f8e1a1e9.jpg";